/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlant2 = createReactComponent("outline", "plant-2", "IconPlant2", [["path", { "d": "M2 9a10 10 0 1 0 20 0", "key": "svg-0" }], ["path", { "d": "M12 19a10 10 0 0 1 10 -10", "key": "svg-1" }], ["path", { "d": "M2 9a10 10 0 0 1 10 10", "key": "svg-2" }], ["path", { "d": "M12 4a9.7 9.7 0 0 1 2.99 7.5", "key": "svg-3" }], ["path", { "d": "M9.01 11.5a9.7 9.7 0 0 1 2.99 -7.5", "key": "svg-4" }]]);

export { IconPlant2 as default };
//# sourceMappingURL=IconPlant2.mjs.map
